<script>
import router from "@/router";

export default {
  name: "ContentsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    contentCategory: {
      default: null,
      validator(value) {
        // The value must match one of these strings
        return typeof value == "object"
      }
    },
    contentType: {
      default: 'post',
      validator(value) {
        // The value must match one of these strings
        return ['post', 'page'].includes(value)
      }
    },
    pauseIfCategoryNotFound: {
      default: true,
    },
  },
  data() {
    return {
      form: {
        type: this.contentType,
        page: 1
      },
      contents: [],
      categories: [],
      paginationMeta: [],
      selectedCategory: null,
    }
  },
  methods: {
    async changePage(page) {
      this.form.page = page

      await this.setContent()

      const contentTypeRouteName = {'post': 'Posts', 'page': 'Pages'};

      router.push({name: contentTypeRouteName[this.contentType], query: {...router.currentRoute.query, page: page}})
    },
    async setCategories() {
      let form = {categories: this.selectedCategory}
      const categories = await this.$store.dispatch('Category/getCategoryWithSlug', form)

      this.categories = await categories.data.data.map(item => {
        return item.id
      });

      this.$emit("categories", this.categories);

    },
    async setContent() {

      const form = this.form
      let filters = {}

      if (this.selectedCategory !== null) {
        filters = {category: this.categories};
      }

      if (this.pauseIfCategoryNotFound && this.selectedCategory != null && this.categories.length === 0) {
        return true;
      }
      const response = await this.$store.dispatch("Content/getContentsWithoutState", {form, filters});
      let data = response.data.data

      this.contents = data.data
      this.paginationMeta = data.meta
      this.$emit("contents", this.contents);
    },
    categoryInRout() {
      this.selectedCategory = null
      if (this.contentCategory != null) {
        this.selectedCategory = this.contentCategory
      }
      const routeCategory = this.$route.query.category;
      if (routeCategory != undefined) {
        this.form.page = 1
        this.selectedCategory = [routeCategory]
      }
      return this.selectedCategory == null ? false : this.selectedCategory
    },
    async initWrapper() {
      const paginatePage = this.$route.query.page;
      if (paginatePage != undefined) {
        this.form.page = paginatePage
      }

      if (this.categoryInRout()) {
        await this.setCategories()
      }
      await this.setContent()
    }
  },
  render() {
    return this.$scopedSlots.default({
      contents: this.contents != undefined ? this.contents.slice(0, this.slicer) : [],
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
    });
  },
  async mounted() {
    await this.initWrapper();
  },
  watch: {
    '$route': {
      handler: function () {
        this.initWrapper();
      },
    },
  }
}
</script>
